import React, { useState, useEffect } from "react";
import "../../css/Subsidies/GrantSubsidyPopup.css";
const GrantSubsidyPopup = ({ participant, reservation, onClose, onGrant, isGranting }) => {
  const [percentage, setPercentage] = useState(null);
  const [subsidyAmount, setSubsidyAmount] = useState('');
  const [error, setError] = useState('');
   const baseCost = Number(participant?.baseCost) || 0;

  useEffect(() => {
    if (percentage !== null) {
      const calculated = Math.ceil(baseCost * (percentage / 100));
      setSubsidyAmount(calculated);
    }
  }, [percentage, baseCost]);

  const handleGrant = () => {
    const subsidy = parseFloat(subsidyAmount);
  
    if (!percentage) {
      setError("Wybierz procent dofinansowania.");
      return;
    }
  
    if (isNaN(subsidy) || subsidy <= 0) {
      setError("Kwota dofinansowania musi być większa od zera.");
      return;
    }
  
    if (subsidy > baseCost) {
      setError("Dofinansowanie nie może przekraczać całkowitego kosztu.");
      return;
    }
  
    setError("");
    onGrant({
      subsidy: subsidy,
      percentage: percentage,
    });
  };
  

  return (
    <div className="grant-popup-overlay">
      <div className="grant-popup">
        <div className="grant-popup-header">Przyznaj dofinansowanie</div>

        <div className="grant-popup-line grant-trip-name">
            <strong className="grant-trip-blue">{reservation.tripName}</strong> – <span className="grant-trip-blue">{reservation.variantName}</span>
            </div>
        <div className="grant-popup-line">{reservation.variantDates}</div>
        <div className="grant-popup-line">
            <strong>Uczestnix:</strong> {participant.name}
            </div>
            <div className="grant-popup-line">
            <span><strong>Koszt:</strong> {participant.baseCost?.toFixed(2)} zł</span>
            </div>
            <div className="grant-popup-line">
            <span><strong>Zaliczka: </strong>{participant.prepayment?.toFixed(2)} zł</span>
            </div>

        <label>Procent dofinansowania:</label>
        <select value={percentage || ""} onChange={(e) => setPercentage(parseInt(e.target.value))}>
          <option value="">Wybierz procent</option>
          <option value="25">25%</option>
          <option value="50">50%</option>
          <option value="75">75%</option>
        </select>

        <label>Dofinansowanie:</label>
        <input
          type="number"
          value={subsidyAmount}
          onChange={(e) => setSubsidyAmount(e.target.value)}
        />

        {error && <div className="grant-popup-error">{error}</div>}

        <div className="grant-popup-actions">
            <div className="subsidy-button cancel" onClick={onClose}>Anuluj</div>
            <div className="subsidy-button" onClick={handleGrant} disabled={isGranting}>
                {isGranting ? (
                <>
                    <i className="fa fa-spinner fa-spin" style={{ marginRight: 6 }}></i> Przyznawanie...
                </>
                ) : (
                "Przyznaj"
                )}
            </div>
        </div>
      </div>
    </div>
  );
};

export default GrantSubsidyPopup;
